import React from 'react';

import styles from './StoryBoxPlaceholder.module.scss';

const StoryBoxPlaceholder = () => (
  <div className={styles.StoryBoxPlaceholder}>
    <div className={styles.Year} />
  </div>
);

export default StoryBoxPlaceholder;



// WEBPACK FOOTER //
// ./src/views/History/placeholder/StoryBox/StoryBoxPlaceholder.js